var app = angular.module('directives.timer');
app.directive('timer', [
    'configs',
    '$translate',
    '$location',
    '$state',
    '$interval',
    '$rootScope',
    function (configs, $translate,
              $location, $state, $interval, $rootScope) {
        return {
            restrict: 'E',
            scope: {
                minutes: '=',
                seconds: '=',
                callback: '&'
            },
            template: require('../templates/timer.html'),
            link: function (scope, element) {
                // Set the date we're counting down to
                var min = Math.floor(scope.minutes * 1000);
                var sec = Math.floor(scope.seconds * 1000 / 60);
                var countDownDate;
                if (sec) {
                    countDownDate = Math.floor(new Date().getTime() + ((sec * (1000 * 60 * 60)) / (1000 * 60)));
                } else {
                    countDownDate = Math.floor(new Date().getTime() + ((min * (1000 * 60 * 60)) / (1000 * 60)));
                }

                // Update the count down every 1 second
                $rootScope.timer = $interval(function () {

                    // Get todays date and time
                    var now = new Date().getTime();

                    // Find the distance between now an the count down date
                    var distance = countDownDate - now;

                    // Time calculations for days, hours, minutes and seconds
                    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    // Display the result in the element
                    if (seconds < 10) {
                        element.text(minutes + ":0" + seconds);
                    } else {
                        element.text(minutes + ":" + seconds);
                    }

                    // If the count down is finished, write some text
                    if (distance < 0) {
                        $interval.cancel($rootScope.timer);
                        element.text("0:00");
                        $rootScope.$broadcast('timerStop');
                        if (scope.callback()) {
                            scope.callback();
                        };
                    }
                }, 100);
            }
        }
    }]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/timer/directives/timer.js
 ** module id = 237
 ** module chunks = 1
 **/